export default __webpack_public_path__ + "static/media/wind_arrow.16d100ea.svg";